export const LOGIN_SUCCESS = 'home/LOGIN_SUCCESS'
export const LOGIN_ERROR = 'home/LOGIN_ERROR'
export const LOGIN = 'home/LOGIN'
